import { Fragment, useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { ActionButton } from 'components';
import { TransferUpahProduksiContext } from '../Context';
import { TablePermintaan } from './TablePermintaan';
import { TableTransfer } from './TableTransfer';

export const TabLabourCostFinishing = () => {
  const { dataPermintaan, dataTransfer, dataHistory, setModalForm } =
    useContext(TransferUpahProduksiContext);

  const showModalKontrak = () =>
    setModalForm((prev) => ({
      ...prev,
      tab: 'lcf',
      action: 'create',
      showRegistrasi: true,
    }));

  return (
    <Fragment>
      <Row className="d-flex justify-content-between align-items-end mb-1">
        <Col>
          <small>List Data Permintaan Labour Cost Finishing</small>
        </Col>

        <Col className="d-flex justify-content-end align-items-end">
          <ActionButton
            size="sm"
            text="Buat Kontrak"
            onClick={showModalKontrak}
          />
        </Col>
      </Row>

      <TablePermintaan tab="lcf" data={dataPermintaan?.lcf ?? []} />

      <small className="mt-2">List Data Transfer Upah Produksi</small>
      <TableTransfer tab="lcf" tipe="editable" data={dataTransfer?.lcf ?? []} />

      <small className="mt-2">History Transfer Upah Produksi</small>
      <TableTransfer tab="lcf" tipe="readonly" data={dataHistory?.lcf ?? []} />
    </Fragment>
  );
};
